import { forwardRef } from 'react';
import type { IconBaseProps } from '../types.js';

export const ThreeStages = forwardRef<SVGSVGElement, IconBaseProps>(
  ({ className, size = 24, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 24 24"
      width={size}
      height={size}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="3.5" y="5" width="17" height="3.5" rx="1.2" stroke="currentColor" strokeWidth="1.8" />
      <rect x="3.5" y="10.3" width="17" height="3.5" rx="1.2" stroke="currentColor" strokeWidth="1.8" />
      <rect x="3.5" y="15.6" width="17" height="3.5" rx="1.2" stroke="currentColor" strokeWidth="1.8" />
    </svg>
  ),
);

ThreeStages.displayName = 'three-stages';
